"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModified = void 0;
const lodash_1 = require("lodash");
const lodash_utils_1 = require("./lodash-utils");
function isModified(updated, old, excludedComparisionPaths) {
    const clean = (obj) => (0, lodash_utils_1.omitDeepNil)((0, lodash_1.omit)(obj, excludedComparisionPaths));
    const changed = !(0, lodash_1.isEqual)(clean(updated), clean(old));
    return changed;
}
exports.isModified = isModified;
//# sourceMappingURL=modifiable.js.map